export default __webpack_public_path__ + "static/media/87t.56abf41d.jpg";